import { ReactNode } from 'react'
import { useSelector } from 'react-redux'
import {
    selectSchoolUserState,
    selectSchoolUserAuthority,
    selectSchoolState,
} from '../../../redux/schoolSlice'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'
import { canAccessMySchool } from '../../../middleware/school'
import { Navigate, useParams } from 'react-router-dom'
import { tabNames } from '../../helpers'
import { SCHOOL_LOADING_ERROR_CODES } from '../../../components/LoadingSpinner/loadingErrorCodes'

export const MySchoolRoute = ({ children }: { children: ReactNode }) => {
    const { schoolId } = useParams()
    const schoolAccountState = useSelector(selectSchoolState)
    const userAccountState = useSelector(selectSchoolUserState)
    const role = useSelector(selectSchoolUserAuthority)

    if (
        schoolAccountState === undefined ||
        userAccountState === undefined ||
        !role
    ) {
        return (
            <LoadingSpinner
                fillViewPortHeight
                fillViewPortWidth
                id="my-school-route-loading"
                errorCode={SCHOOL_LOADING_ERROR_CODES.SCHOOL_ACCESS.code}
            />
        )
    }

    if (!canAccessMySchool(schoolAccountState, userAccountState, role)) {
        return (
            <Navigate to={`${tabNames.app.school.index}/${schoolId}`} replace />
        )
    }

    return children
}

export const BookingsRoute = ({ children }: { children: ReactNode }) => {
    const { schoolId } = useParams()
    const schoolState = useSelector(selectSchoolState)
    const userState = useSelector(selectSchoolUserState)

    if (schoolState === undefined || userState === undefined)
        return (
            <LoadingSpinner
                fillViewPortHeight
                fillViewPortWidth
                id="bookings-route-loading"
                errorCode={SCHOOL_LOADING_ERROR_CODES.BOOKINGS_ACCESS.code}
            />
        )

    if (schoolState !== 'approved' || userState !== 'approved') {
        return (
            <Navigate to={`${tabNames.app.school.index}/${schoolId}`} replace />
        )
    }

    return children
}

export const HomeRoute = ({ children }: { children: ReactNode }) => {
    const { schoolId } = useParams()
    const schoolState = useSelector(selectSchoolState)
    const userState = useSelector(selectSchoolUserState)
    if (schoolState === undefined || userState === undefined)
        return (
            <LoadingSpinner
                fillViewPortHeight
                fillViewPortWidth
                errorCode={SCHOOL_LOADING_ERROR_CODES.SCHOOL_HOME.code}
            />
        )

    if (schoolState === 'approved' && userState === 'approved') {
        return (
            <Navigate
                to={`${tabNames.app.school.index}/${schoolId}/bookings/upcoming`}
                replace
            />
        )
    }

    return children
}
